import React, { useState, useEffect } from 'react'
import MetricCard from '../components/(admin)/MetricCard'
import RequestOverTimeChart from '../components/(admin)/RequestOverTimeChart'
import BarChart from '../components/(admin)/BarChart'
import UsageDataTable from '../components/(admin)/UsageDataTable'
import { usageReportsAPI } from '../services/(adminapi)/usageReportsAPI'
import './UsageReports.css'

const UsageReports = () => {
  const [loading, setLoading] = useState(true)
  const [metrics, setMetrics] = useState({
    totalMessages: 0,
    uniqueCustomers: 0,
    uniqueMessages: 0,
    adminTeamMessages: 0
  })
  const [messagesOverTime, setMessagesOverTime] = useState([])
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchUsageData()
  }, [])

  const fetchUsageData = async () => {
    try {
      setLoading(true)
      const response = await usageReportsAPI.getUsageMetrics(30)
      
      if (response.data.success) {
        const data = response.data.data
        setMetrics({
          totalMessages: data.totalMessages || 0,
          uniqueCustomers: data.uniqueCustomers || 0,
          uniqueMessages: data.uniqueMessages || 0,
          adminTeamMessages: data.adminTeamMessages || 0
        })
        setMessagesOverTime(data.messagesOverTime || [])
        // Table data can be populated from detailed stats if needed
        setTableData([])
      } else {
        // If API returns unsuccessful, just use default values (0)
        setMetrics({
          totalMessages: 0,
          uniqueCustomers: 0,
          uniqueMessages: 0,
          adminTeamMessages: 0
        })
        setMessagesOverTime([])
        setTableData([])
      }
    } catch (err) {
      // Log error for debugging but don't show to user
      console.error('Error fetching usage data:', err)
      // On error, just use default values (0) - show blank charts
      setMetrics({
        totalMessages: 0,
        uniqueCustomers: 0,
        uniqueMessages: 0,
        adminTeamMessages: 0
      })
      setMessagesOverTime([])
      setTableData([])
    } finally {
      setLoading(false)
    }
  }

  // Metric cards data
  const metricData = [
    { title: 'Total Messages', value: metrics.totalMessages, format: 'number' },
    { title: 'Unique Customers', value: metrics.uniqueCustomers, format: 'number' },
    { title: 'Unique Messages', value: metrics.uniqueMessages, format: 'number' },
    { title: 'Admin Team Messages', value: metrics.adminTeamMessages, format: 'number' }
  ]

  // Format messages over time for chart
  const apiCallsOverTimeData = messagesOverTime.length > 0 
    ? messagesOverTime.map(item => ({
        date: item.date || '',
        value: item.value || 0
      }))
    : []

  // Static data for Token Usage by Business bar chart (can be updated later with real data)
  // Show empty array if no data to let chart component handle it gracefully
  const tokenUsageByBusinessData = []

  if (loading) {
    return (
      <div className="usage-reports-container">
        <h1 className="page-title">Usage Reports</h1>
        <div style={{ textAlign: 'center', padding: '2rem' }}>Loading usage data...</div>
      </div>
    )
  }

  return (
    <div className="usage-reports-container">
      <h1 className="page-title">Usage Reports</h1>
      
      {/* Metric Cards Row */}
      <div className="metrics-grid">
        {metricData.map((metric, index) => (
          <MetricCard
            key={index}
            title={metric.title}
            value={metric.value}
            format={metric.format}
          />
        ))}
      </div>

      {/* Charts Row */}
      <div className="charts-grid">
        {/* Messages Over Time Chart */}
        <RequestOverTimeChart 
          data={apiCallsOverTimeData}
          title="Messages Over Time"
        />

        {/* Token Usage by Business Bar Chart */}
        <BarChart 
          title="Token Usage by Business"
          data={tokenUsageByBusinessData}
        />
      </div>

      {/* Data Table Section */}
      <div className="table-section">
        <UsageDataTable data={tableData} />
      </div>
    </div>
  )
}

export default UsageReports
